import {isUUID} from "../../../utils/strings";
import {COLD_PALETTE} from "../../../utils/colorUtils";
import {reduceToCommonDates} from "../../../utils/dataTransforms";



export const formatDataForStockChart = (portfolioTimeSeries, benchmarkTimeSeries, extraTimeseries, snapshotCallback, portfolio)=>{
    const [alignedPortfolioSeries, alignedBenchmarkSeries] = reduceToCommonDates([portfolioTimeSeries, benchmarkTimeSeries]);
    const dataSeries = [];
    if (portfolioTimeSeries) {
        dataSeries.push({
            name: portfolio?.name,
            type: 'line',
            data: alignedPortfolioSeries.map(x => [x.timestamp, x.close, x.snapshot]),
            stroke: '#0083ff',
            thickness: 2,
            hasSnapshot: true,
            callbackOnSnapshot: snapshotCallback
        });
    }


    if (benchmarkTimeSeries){
        dataSeries.push({
            name: portfolio?.benchmark,
            type: 'area',
            data: alignedBenchmarkSeries.map(x => [x.timestamp, x['adj close']]),
            stroke: '#4d5d70',
            thickness: 1,
            fill: {
                keys: ['rgba(255, 255, 255, 0.3)', 'rgba(179, 193, 211, 1)'],
                angle: 90
            }
        });
    }
    if (extraTimeseries){
        extraTimeseries.forEach((extraSeries, index)=>{
            if (extraSeries.symbol !== portfolio?.benchmark && !isUUID(extraSeries.symbol))
            dataSeries.push({
                name: extraSeries.symbol,
                type: 'line',
                data: extraSeries.data.map(x => [x.timestamp, x['adj close']]),
                stroke: COLD_PALETTE[index < COLD_PALETTE.length ? index : index % COLD_PALETTE.length],
                strokeWidth: 2,
            });
        })
    }
    return dataSeries;
}


const _transformSnapshot = (snapshot) => {
    const items = [];
    for (let symbol in snapshot) {
        items.push({symbol, weight: snapshot[symbol].wgt});
    }
    return items;
}


/**
 * Calculate the delta (change) between snapshots and return a new array of objects
 * with the 'timestamp' and 'value' fields.
 *
 * @param {Array} series - Array of objects containing 'timestamp' and 'snapshot' fields.
 *                         'snapshot' should be an array of objects with 'symbol' and 'weight' fields.
 * @returns {Array} - Array of arrays with each element in the format [timestamp, value],
 *                    where 'value' is the sum of absolute changes in weights between consecutive snapshots.
 */
export const getDeltaSeries = (series)=> {
    let deltaSeries = [];
    for (let i = 1; i < series.length; i++) {
        const previousSnapshot = _transformSnapshot(series[i - 1].snapshot);
        const currentSnapshot = _transformSnapshot(series[i].snapshot);
        const timestamp = series[i].timestamp;

        // Create a map of symbols to their weights for easier lookup
        const previousWeights = new Map(previousSnapshot.map(item => [item.symbol, item.weight]));
        const currentWeights = new Map(currentSnapshot.map(item => [item.symbol, item.weight]));

        // Calculate the total absolute change in weights
        let totalChange = 0;

        // Iterate through all symbols in the current snapshot
        for (let [symbol, currentWeight] of currentWeights) {
            const previousWeight = previousWeights.get(symbol) || 0;
            totalChange += Math.abs(currentWeight - previousWeight);
        }

        // Also consider symbols that were in the previous snapshot but not in the current one
        for (let [symbol, previousWeight] of previousWeights) {
            if (!currentWeights.has(symbol)) {
                totalChange += Math.abs(previousWeight);
            }
        }
        if (totalChange>0) {
            totalChange *= 100;
        }

        deltaSeries.push([timestamp, totalChange]);
    }

    return deltaSeries;
}

